import React, { useState, useMemo } from "react";
import TreeNode from "./TreeNode";

const TreeView = ({
  data,
  title,
  onChange,
  handleSelectItem,
  onDoubleClick,
  template,
}) => {
  const [expanded, setExpanded] = useState({});
  const [selectedId, setSelectedId] = useState(null);
  const [newItemName, setNewItemName] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [newItemType, setNewItemType] = useState("menu");

  const toggle = (id) => setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));

  // Build tree from flat array
  const buildTree = (items) => {
    const map = {};
    const roots = [];
    items.forEach((item) => (map[item.id] = { ...item, children: [] }));
    items.forEach((item) => {
      if (item.parentId === 0) roots.push(map[item.id]);
      else if (map[item.parentId])
        map[item.parentId].children.push(map[item.id]);
    });
    return roots;
  };

  const tree = useMemo(() => buildTree(data), [data]);

  const handleAdd = () => {
    if (!newItemName.trim()) return;

    const selectedNode = data.find((i) => i.id === selectedId);
    const isDir = newItemType === "directory";

    const newItem = {
      id: Math.max(...data.map((i) => i.id)) + 1,
      name: newItemName.trim(),
      parentId: selectedNode
        ? selectedNode.isDirectory
          ? selectedNode.id
          : selectedNode.parentId
        : 0,
      isDirectory: isDir,
      children: [],
    };

    onChange([...data, newItem]);
    setNewItemName("");
    setShowInput(false);

    // Expand the parent directory automatically
    if (selectedNode && selectedNode.isDirectory) {
      setExpanded((prev) => ({ ...prev, [selectedNode.id]: true }));
    }
  };

  const handleDrop = (dragId, dropId) => {
    const dragged = data.find((i) => i.id === dragId);
    const dropped = data.find((i) => i.id === dropId);
    if (!dragged || !dropped) return;

    if (isDescendant(dragged.id, dropped.id)) return;

    const updated = data.map((item) =>
      item.id === dragged.id ? { ...item, parentId: dropped.id } : item
    );
    onChange(updated);
  };

  const handleReorder = (dragId, dropId, parentId) => {
    const dragged = data.find((i) => i.id === dragId);
    if (!dragged) return;

    const siblings = data
      .filter((i) => i.parentId === parentId && i.id !== dragId)
      .sort((a, b) => data.indexOf(a) - data.indexOf(b));

    const dropIndex = siblings.findIndex((i) => i.id === dropId);
    const newSiblings = [
      ...siblings.slice(0, dropIndex + 1),
      dragged,
      ...siblings.slice(dropIndex + 1),
    ];

    const updated = [
      ...data.filter((i) => i.parentId !== parentId),
      ...newSiblings,
    ];
    console.log(updated, "kkkkkkkkkkkkkkkkkkkkkk");
    onChange(updated);
  };

  const isDescendant = (sourceId, targetId) => {
    const findChildren = (parentId) => {
      const children = data.filter((i) => i.parentId === parentId);
      for (let child of children) {
        if (child.id === targetId) return true;
        if (findChildren(child.id)) return true;
      }
      return false;
    };
    return findChildren(sourceId);
  };

  return (
    <div style={{ border: "1px solid #ddd", padding: 10, borderRadius: 4 }}>
      <h4>{title}</h4>

      {tree.map((n) => (
        <TreeNode
          key={n.id}
          node={n}
          expanded={expanded}
          toggle={toggle}
          onDrop={handleDrop}
          onReorder={handleReorder}
          selectedId={selectedId}
          setSelected={setSelectedId}
          handleSelectItem={handleSelectItem}
          onDoubleClick={onDoubleClick}
          template={template}
        />
      ))}

      {/* Buttons to add menu/directory */}
      {/* {selectedId && (
        <div style={{ marginTop: 10 }}>
          {data.find((i) => i.id === selectedId)?.isDirectory ? (
            <>
              <button
                onClick={() => {
                  setNewItemType("menu");
                  setShowInput(true);
                }}
              >
                Add Menu
              </button>
              <button
                onClick={() => {
                  setNewItemType("directory");
                  setShowInput(true);
                }}
              >
                Add Directory
              </button>
            </>
          ) : (
            <button
              onClick={() => {
                setNewItemType("menu");
                setShowInput(true);
              }}
            >
              Add Menu
            </button>
          )}
        </div>
      )} */}

      {/* Input for new item name */}
      {/* {showInput && (
        <div style={{ marginTop: 5 }}>
          <input
            type="text"
            value={newItemName}
            onChange={(e) => setNewItemName(e.target.value)}
            placeholder={`Enter ${newItemType} name`}
          />
          <button onClick={handleAdd}>Add</button>
        </div>
      )} */}
    </div>
  );
};

export default TreeView;
